import React from "react";
import * as EventosEquipos from "../constantes/EventosEquiposTorneos.js";
import * as Iconos from "./Iconos.js";
import styles from "./Iconos.module.css";

export const IconoMovimiento = (props) => {
  const objeto = props.objeto;

  let source = null;
  let alt = null;
  if (objeto && objeto.movimientoDivisional) {
    if (objeto.movimientoDivisional === EventosEquipos.ASCENSO) {
      source = Iconos.cambioEntra;
      alt = "Ascendió";
    } else if (objeto.movimientoDivisional === EventosEquipos.DESCENSO) {
      source = Iconos.cambioSale;
      alt = "Descendió";
    }
  }

  return (
    <React.Fragment>
      {source && (
          <img
          className={`${styles.iconoMovimiento}`}
          src={source}
          id={objeto.id}
          key={alt + objeto.id}
          alt={alt}
        />
      )}
    </React.Fragment>
  );

};

export default IconoMovimiento;
